import GlsRegulatory from '../cms-components/blackrock/advisor-center/gls-regulatory/GlsRegulatory';

export const GlsRegulatoryComponent = GlsRegulatory;
